import React, { useState } from 'react';
import {
  TextField,
  Box,
  IconButton
} from '@mui/material';
import { TableChart as TableChartIcon } from '@mui/icons-material';
import { useQuery } from '@apollo/client';
import { GET_ALL_VAT_EXEMPTION_REASONS } from '../graphql/queries';
import { VatExemptionSearchModal } from './VatExemptionSearchModal';

export const VatExemptionAutocomplete = ({
  value,
  onChange,
  disabled = false,
  required = false,
  error = false,
  helperText = '',
  size = 'small',
  fullWidth = true
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data } = useQuery(GET_ALL_VAT_EXEMPTION_REASONS);

  const exemptionReasons = React.useMemo(() => {
    if (!data?.allVatExemptionReasons) return [];
    return data.allVatExemptionReasons
      .filter(reason => reason.isActive)
      .sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
  }, [data]);

  // Find the selected value object
  const selectedValue = React.useMemo(() => {
    if (!value || !exemptionReasons.length) return null;
    return exemptionReasons.find(r => r.id === value) || null;
  }, [value, exemptionReasons]);

  const handleReasonSelected = (reason) => {
    onChange(reason.id);
    setIsModalOpen(false);
  };

  // Display text for selected value
  const displayText = selectedValue
    ? `${selectedValue.reasonName} (${selectedValue.legalBasis})`
    : '';

  return (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, width: fullWidth ? '100%' : 'auto' }}>
      <TextField
        value={displayText}
        onClick={() => !disabled && setIsModalOpen(true)}
        label="Основание за неначисляване на ДДС"
        placeholder="Кликнете за избор на основание..."
        required={required}
        error={error}
        helperText={helperText || (selectedValue ? `UBL: ${selectedValue.ublExemptionCode || selectedValue.reasonCode}` : 'Изберете основание от списъка')}
        disabled={disabled}
        size={size}
        fullWidth
        InputProps={{
          readOnly: true,
          sx: { cursor: disabled ? 'default' : 'pointer' }
        }}
        sx={{
          '& .MuiInputBase-input': {
            cursor: disabled ? 'default' : 'pointer'
          }
        }}
      />
      <IconButton
        onClick={() => setIsModalOpen(true)}
        color="primary"
        title="Отвори пълна таблица с основания"
        disabled={disabled}
        sx={{ mt: size === 'small' ? 0.5 : 1 }}
      >
        <TableChartIcon />
      </IconButton>

      <VatExemptionSearchModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onReasonSelected={handleReasonSelected}
        currentReasonId={value}
      />
    </Box>
  );
};

export default VatExemptionAutocomplete;
